import * as actionTypes from './actions';

export const initialState = {
  clinicCoordinators: [],
};

// -----------------------|| CUSTOMIZATION REDUCER ||-----------------------//

const backendDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CLINIC_COORDINATORS:
      return {
        ...state,
        clinicCoordinators: action.clinicCoordinators,
      };
    default:
      return state;
  }
};

export default backendDataReducer;
